import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import { baseTheme, Divider as SidekickDivider } from "@avenue-8/sidekick-ui";

export const FooterContainer = styled.footer`
  width: 100%;
  padding: 4rem 0 2rem;
  background-color: ${baseTheme.colors.blue5};

  ${(p) => p.theme.media.mobileDown} {
    padding: 2.5rem 0 1.5rem;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;

  ${(p) => p.theme.media.laptopDown} {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 8rem 0 3rem;

  ${(p) => p.theme.media.desktopDown} {
    padding: 0 6rem 0 2rem;
  }

  ${(p) => p.theme.media.laptopDown} {
    justify-content: flex-start;
    padding: 0 2rem;
  }

  ${(p) => p.theme.media.mobileDown} {
    padding: 0 1.5rem;
  }
`;

export const LeftColumnInner = styled.div`
  width: 100%;
  max-width: 600px;
`;

export const RightColumn = styled.div`
  padding: 0 3rem 0 8rem;

  ${(p) => p.theme.media.desktopDown} {
    padding: 0 3rem 0 6rem;
  }

  ${(p) => p.theme.media.laptopDown} {
    padding: 0 2rem;
  }

  ${(p) => p.theme.media.mobileDown} {
    padding: 0 1.5rem;
  }
`;

export const BrandBlock = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 320px;
`;

export const BrandLogo = styled.img`
  width: fit-content;
  align-self: flex-start;
`;

export const Tagline = styled(Typography)`
  color: ${baseTheme.colors.state1};
  margin-top: 1rem;
`;

export const ColumnsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 5rem;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
`;

export const ColumnTitle = styled(Typography)`
  color: ${baseTheme.colors.white};
  font-weight: 700;
`;

export const ColumnLink = styled.a`
  color: ${baseTheme.colors.state1};
  font-size: 14px;
  text-decoration: underline;

  &:hover {
    color: ${baseTheme.colors.white};
  }
`;

export const LinkButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  color: ${baseTheme.colors.state1};
  font-size: 14px;
  text-decoration: underline;

  &:hover {
    color: ${baseTheme.colors.white};
  }
`;

export const Address = styled(Typography)`
  color: ${baseTheme.colors.state1};
  font-size: 14px;
`;

export const Divider = styled(SidekickDivider)`
  border-color: rgba(255, 255, 255, 0.15);
  margin: 3rem auto 1.5rem;
  max-width: 1456px;

  ${(p) => p.theme.media.desktopDown} {
    margin: 3rem 2rem 1.5rem;
  }

  ${(p) => p.theme.media.mobileDown} {
    margin: 2rem 1.5rem 1.5rem;
  }
`;

export const Copyright = styled(Typography)`
  color: ${baseTheme.colors.state1};
  text-align: center;
`;
